import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { finalizeMediaUtil, initializeMediaUtil, uploadOnS3 } from "../../../utils/mediaUtils";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey } from "../../../api/api.keys";
import { CreateAlbum } from "../../../api/api.service";
import SubscriptionStatus, { SUBSCRIPTION_STATUS } from "../../../constants/SubscriptionStatus";
import { APP_ROUTES } from "../../../helpers/routeHelpers";
import AudioSoundscapeForm from "./AudioSoundscapeForm";
import { showToast, SUCCESS } from "../../../utils/toastUtils";

const AddSoundscape = () => {
    const history = useHistory();
    let { useMutate } = useRequestProcessor();
    const [isMediaUpload, setIsMediaUpload] = useState(false);
    let { mutate, isLoading } = useMutate("", getKey(), (data) => CreateAlbum(data));

    // media upload on server
    const handleMediaUpload = async (file, initFile) => {
        return initializeMediaUtil(file).then(async (res) => {
            const credentials = res;
            try {
                await uploadOnS3(initFile, credentials);
            } catch (err) {}

            return await finalizeMediaUtil(credentials?.mediaId);
        });
    };

    const addAudioHandler = async (values) => {
        try {
            setIsMediaUpload(true);
            const uploadResults = await Promise.all(
                Object.keys(values).map(async (fieldName) => {
                    const fieldData = values[fieldName];
                    if (fieldData?.file) {
                        const mediaId = await handleMediaUpload(
                            fieldData.file,
                            fieldData?.exactFile
                        );
                        return { fieldName, mediaId };
                    }
                    return null;
                })
            );

            // Attach mediaIds to form values
            uploadResults.forEach((result) => {
                if (result) {
                    const { fieldName, mediaId } = result;
                    values[fieldName].mediaId = mediaId;
                }
            });

            const bodyData = {
                title: values.title,
                description: values.description,
                authorId: Number(values.author?.value), // Convert to number
                categoryId: 3, // Static value for now, but ensure it's a number
                labelIds: values.subCategory?.map((item) => item.value),
                thumbnailId: Number(values.uploadImage?.mediaId?.id), // Convert to number
                croppedThumbnailId: Number(values.uploadThumbnail?.mediaId?.id), // Convert to number
                tierType:
                    values.radioGroup ===
                    SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.FREEMIUM)
                        ? SUBSCRIPTION_STATUS.FREEMIUM
                        : SUBSCRIPTION_STATUS.PREMIUM, // Use valid enum
                audios: [
                    {
                        title: values.title,
                        description: values.description,
                        duration: Math.floor(Number(values.sessionUploadAudio?.file?.duration)), // Convert to number
                        audioMediaId: Number(values.sessionUploadAudio?.mediaId?.id), // Convert to number
                        tierType:
                            values.radioGroup ===
                            SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.FREEMIUM)
                                ? SUBSCRIPTION_STATUS.FREEMIUM
                                : SUBSCRIPTION_STATUS.PREMIUM, // Use valid enum
                        completionMessage: values.sessionCompletionmessage
                    }
                ]
            };

            mutate(bodyData, {
                onSuccess: async (res) => {
                    showToast(SUCCESS, "Soundscape Audio Created Successfully!");
                    history.push(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES);
                    setIsMediaUpload(false);
                },
                onError: (err) => {
                    console.log("not cerated", err);
                    setIsMediaUpload(false);
                }
            });
        } catch (error) {
            console.error("Error during form submission:", error);
            setIsMediaUpload(false);
        }
    };

    return (
        <AudioSoundscapeForm
            mode="add"
            isLoading={isLoading || isMediaUpload}
            onAddAudio={addAudioHandler}
            isDisabled={isMediaUpload}
        />
    );
};

export default AddSoundscape;
